import styled from 'styled-components';
import { Form } from '@bynder/design-system';

export const FormRow2to1 = styled(Form.Row)`
    grid-template-columns: 2fr 1fr;
`;
